/* Load Modules */
import React, {Component} from "react";
import _ from "lodash";

/* Load Components */
import FormSetWays from "../../../../../../utils/forms/components/FormSetWays";
import {Dialog} from "../../../../../../utils/Dialog/Dialog.component";

/* Load Redux Store */
import {connect} from "react-redux";
import {configurationsStoreSelectors} from "../../../../store/store";
import {
    TerminalGroupConfiguration,
    GameGroupConfiguration,
    SpecialPrizeConfiguration,
    GROUP_TYPE
} from "../../../../reducers/editingConfiguration.reducer";
import {DenominationsList} from "../../../../reducers/denominations.reducer";
import {ConfigurationsActionCreators} from "../../../../actions/actionCreators";
import {ActionCreator} from "../../../../../../actions/actions";

import {ProgressiveRulesSchema} from "../../../../reducers/schema.reducer";

/* Load Forms */
import {
    pigBoomSubForms,
    mrChampionSubForms
} from "./FormBuild/SpecialPrizesConfigurationSection.forms";
import {SelectedGroupsByProgressive} from "../../../../models/SelectedGroupsByProgressive";

import "./SpecialPrizesConfigurationSection.component.scss";

import {checkAvailablePrizeTypes} from "../../../Utils/check-available-prizes";
import {ConfigurationsActionTypes} from "../../../../actions/actionTypes";

export interface SpecialPrizesConfigurationSectionProps {
    schema: any;
    mrChampionSchema: any;
    pigBoomSchema: any;
    denominationsList: DenominationsList;
    groupsConfig: TerminalGroupConfiguration[];
    gameGroupsConfig: GameGroupConfiguration[];
    updateSpecialPrizesConfig: ActionCreator;
    mrChampionConfig: SpecialPrizeConfiguration[];
    pigBoomConfig: SpecialPrizeConfiguration[];
    terminalGroups: TerminalGroupConfiguration[];
    gameGroups: GameGroupConfiguration[];
    selectedTerminalGroups: SelectedGroupsByProgressive;
    selectedGameGroups: SelectedGroupsByProgressive;
    selectedGroupType: GROUP_TYPE;
    editingConfiguration: any;
    configSectionVisited: ActionCreator;
    progressiveRules: ProgressiveRulesSchema[];
}

const defaultState = {
    showDialog: false,
    indexToDelete: null,
    deleteCallback: null,
    warning: ''
};

var hasPigboom = false;
var hasMrChampion = false;

class SpecialPrizesConfigurationSection extends Component<
    SpecialPrizesConfigurationSectionProps,
    {
        showDialog: boolean;
        indexToDelete: number;
        deleteCallback: any;
        warning: string;
    }
> {
    private previousMrChampionValue = {values: [], isValid: true};
    private previousPigBoomValue = {values: [], isValid: true};
    mrChampionFormSet: React.RefObject<FormSetWays>;
    pigBoomFormSet: React.RefObject<FormSetWays>;
    private generalError = ""

    constructor(props) {
        super(props);

        this.state = defaultState;
        this.onDialogConfirm = this.onDialogConfirm.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);

        this.mrChampionFormSet = React.createRef();
        this.pigBoomFormSet = React.createRef();
    }

    componentDidMount() {
        this.props.configSectionVisited(
            ConfigurationsActionTypes.UPDATE_SPECIAL_PRIZES_CONFIG
        );

        if (this.mrChampionFormSet && this.mrChampionFormSet.current) {
            this.mrChampionFormSet.current.fireChange();
        }

        if (this.pigBoomFormSet && this.pigBoomFormSet.current) {
            this.pigBoomFormSet.current.fireChange();
        }

        const game_types =
            this.props.editingConfiguration.settings.settings.settings
                .game_types;

        const {mrChampion, pigBoom} = checkAvailablePrizeTypes(
            this.props.editingConfiguration.settings.settings.settings
        );
        hasMrChampion = mrChampion;
        hasPigboom = pigBoom;
        if (!game_types.includes("Bingo") ||
            (mrChampion === false && pigBoom === false)
        ) {
            this.props.updateSpecialPrizesConfig({
                config: [],
                isValid: true,
                groupType: this.props.selectedGroupType
            });
        }
    }

    onDialogClose = () => {
        this.setState(defaultState);
    };

    onDeletePrize = (deleteCallback, index) => {
        this.setState({
            showDialog: true,
            indexToDelete: index,
            deleteCallback
        });
    };

    onDialogConfirm = () => {
        this.state.deleteCallback(this.state.indexToDelete);
        this.setState(defaultState);
    };

    onMrChampionChange = formEvent => {
        this.previousMrChampionValue = {...formEvent};
        this.generalError = "";
        this.previousMrChampionValue.values.map(
            value => {
                if (value['max_value'] < value['initial_value'] + value['min_sort']) {
                    this.previousMrChampionValue.isValid = false
                    this.generalError = "Maximum Value must be > or equal then Initial Value + Min. Sort."
                }
                if (value['max_value'] < value['initial_value'] + value['max_sort']) {
                    this.previousMrChampionValue.isValid = false
                    this.generalError = "Maximum Value must be > or equal then Initial Value + Max. Sort."
                }
            }
        )
        this.setState({
            warning: this.generalError
        });
        this.props.updateSpecialPrizesConfig({
            config: [
                ...this.previousMrChampionValue.values,
                ...this.previousPigBoomValue.values
            ],
            isValid:
                this.previousMrChampionValue.isValid &&
                this.previousPigBoomValue.isValid &&
                (hasMrChampion && this.previousMrChampionValue.values.length > 0) &&
                this.props.selectedGroupType,
            groupType: this.props.selectedGroupType
        });
    };

    onPigBoomChange = formEvent => {
        this.previousPigBoomValue = {...formEvent};

        this.props.updateSpecialPrizesConfig({
            config: [
                ...this.previousMrChampionValue.values,
                ...this.previousPigBoomValue.values
            ],
            isValid:
                this.previousMrChampionValue.isValid &&
                this.previousPigBoomValue.isValid &&
                (hasPigboom && this.previousPigBoomValue.values.length > 0) &&
                this.props.selectedGroupType,
            groupType: this.props.selectedGroupType
        });
    };

    shouldComponentUpdate(nextProps, _nextState) {
        return (
            this.props.pigBoomConfig.length !==
            nextProps.pigBoomConfig.length ||
            this.props.mrChampionConfig.length !==
            nextProps.mrChampionConfig.length ||
            !_.isEqual(
                this.props.selectedGameGroups,
                nextProps.selectedGameGroups
            ) ||
            !_.isEqual(
                this.props.selectedTerminalGroups,
                nextProps.selectedTerminalGroups
            ) ||
            !_.isEqual(this.state.showDialog, _nextState.showDialog)
            ||
            !_.isEqual(this.state.warning, _nextState.warning)
        );
    }

    addMrChampion = () => {
        this.mrChampionFormSet.current.onAdd(0);
    };

    addPigBoom = () => {
        this.pigBoomFormSet.current.onAdd(0);
    };

    render() {
        const game_types =
            this.props.editingConfiguration.settings.settings.settings
                .game_types;

        const {mrChampion, pigBoom} = checkAvailablePrizeTypes(
            this.props.editingConfiguration.settings.settings.settings
        );

        if (
            game_types.length == 0 ||
            !game_types.includes("Bingo") ||
            (mrChampion === false && pigBoom === false)
        ) {
            return (
                <div id="SpecialPrizesConfigurationSection">
                    <div className="row">
                        <div className="empty-prize-types">
                            <p>
                                <i className="icon-exclamation-circle-light"></i>
                                The game type Bingo must be selected in General
                                Settings and Pig Boom or Mr Champion selected,
                                to be able to add Special Prizes.
                            </p>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div id="SpecialPrizesConfigurationSection">
                <div className="row">
                    {mrChampion && (
                        <div className="col-12" id="mr-champion-container">
                            <div className="inner-card">
                                <div className="inner-card-title">
                                    <p>
                                        Mr. Champion
                                        <span>{` (${this.props.mrChampionConfig.length})`}</span>
                                    </p>
                                    <button onClick={this.addMrChampion}>
                                        <i className="icon-plus-light"></i>
                                    </button>
                                </div>
                                <div className="inner-card-content">
                                    <FormSetWays
                                        isConfig={true}
                                        subFormTypes={mrChampionSubForms(
                                            this.props
                                        )({
                                            terminalGroups:
                                            this.props.terminalGroups,
                                            gameGroups: this.props.gameGroups,
                                            selectedTerminalGroups:
                                            this.props
                                                .selectedTerminalGroups,
                                            selectedGameGroups:
                                            this.props.selectedGameGroups,
                                            schema: this.props.schema,
                                            selectedGroupType:
                                            this.props.selectedGroupType,
                                            mrChampionConfig:
                                            this.props.mrChampionConfig,
                                            rules: this.props.progressiveRules["mrchampion"]
                                        })}
                                        initialValues={
                                            this.props.mrChampionConfig
                                        }
                                        ref={this.mrChampionFormSet}
                                        onChange={this.onMrChampionChange}
                                        hideAdd={true}
                                        onDelete={this.onDeletePrize}
                                        generalError={this.state.warning}
                                        presets={this.props.progressiveRules["mrchampion"]}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {pigBoom && (
                        <div className="col-12" id="pig-boom-container">
                            <div className="inner-card">
                                <div className="inner-card-title">
                                    <p>
                                        Pig Boom
                                        <span>{` (${this.props.pigBoomConfig.length})`}</span>
                                    </p>
                                    <button onClick={this.addPigBoom}>
                                        <i className="icon-plus-light"></i>
                                    </button>
                                </div>
                                <div className="inner-card-content">
                                    <FormSetWays
                                        isConfig={true}
                                        subFormTypes={pigBoomSubForms(
                                            this.props
                                        )({
                                            terminalGroups:
                                            this.props.terminalGroups,
                                            gameGroups: this.props.gameGroups,
                                            selectedTerminalGroups:
                                            this.props
                                                .selectedTerminalGroups,
                                            selectedGameGroups:
                                            this.props.selectedGameGroups,
                                            schema: this.props.schema,
                                            selectedGroupType:
                                            this.props.selectedGroupType,
                                            pigBoomConfig:
                                            this.props.pigBoomConfig,
                                            rules: this.props.progressiveRules["pigboom"]
                                        })}
                                        initialValues={this.props.pigBoomConfig}
                                        hideAdd={true}
                                        ref={this.pigBoomFormSet}
                                        onChange={this.onPigBoomChange}
                                        onDelete={this.onDeletePrize}
                                        presets={this.props.progressiveRules["pigboom"]}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <Dialog
                        open={this.state.showDialog}
                        onConfirm={this.onDialogConfirm}
                        onClose={this.onDialogClose}
                    >
                        You are about to delete a Special Prize configuration.
                        Are you sure?
                    </Dialog>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    updateSpecialPrizesConfig:
    ConfigurationsActionCreators.updateSpecialPrizesConfig,
    configSectionVisited: ConfigurationsActionCreators.configSectionVisited
};

const mapStateToProps = state => ({
    terminalGroups: configurationsStoreSelectors.terminalGroups(state),
    selectedTerminalGroups:
        configurationsStoreSelectors.selectedTerminalGroups(state),
    gameGroups: configurationsStoreSelectors.gameGroups(state),
    selectedGameGroups: configurationsStoreSelectors.selectedGameGroups(state),
    schema: configurationsStoreSelectors.specialPrizesSchema(state),
    mrChampionSchema: configurationsStoreSelectors.mrChampionSchema(state),
    pigBoomSchema: configurationsStoreSelectors.pigBoomSchema(state),
    selectedGroupType: configurationsStoreSelectors.selectedGroupType(state),
    groupsConfig: configurationsStoreSelectors.groupsConfig(state),
    gameGroupsConfig: configurationsStoreSelectors.gameGroupsConfig(state),
    mrChampionConfig: configurationsStoreSelectors.mrChampionConfig(state),
    pigBoomConfig: configurationsStoreSelectors.pigBoomConfig(state),
    denominationsList: configurationsStoreSelectors.denominationsList(state),
    editingConfiguration:
        configurationsStoreSelectors.editingConfiguration(state),
    progressiveRules: configurationsStoreSelectors.progressiveRules(state),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SpecialPrizesConfigurationSection);
